import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    FormControl,
    FormGroup,
    REACTIVE_FORM_DIRECTIVES,
    Validators
} from "@angular/forms";
import {AlertComponent, TYPEAHEAD_DIRECTIVES} from "ng2-bootstrap/ng2-bootstrap";
import {VehiclesService} from "../service/vehicles.service";
import {ContractsService} from "../service/contracts.service";
import {ProcedureService} from "../service/procedure.service";
import {BankService} from "../service/bank.service";
import {Vehicle} from "../domain/vehicle";
import {DEFAULT_ERROR_MESSAGES} from "../validators/validators";
import {Contract} from "../domain/contract";
import {NavigationService} from "../service/navigation.service";
import {User} from "../domain/user";
import {LoginService} from "../service/login.service";

@Component({
    selector: 'pendingProcedures-editor',
    template: require('./pendingProcedures.editor.component.html'),
    styles: [require('./pendingProcedures.editor.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        /*MyDatePicker,*/
        TYPEAHEAD_DIRECTIVES
    ],
    providers: [FORM_PROVIDERS],
})
export class PendingProcedureEditorComponent implements OnInit, OnDestroy {

    private sub: any;

    public errorMessages: any;
    public form: FormGroup;


    public contractValid: boolean;

    public vehicles: Vehicle[];
    public contract: Contract;
    private vehicleId: string;

    private procedureId: string;

    private canEditVehicle: boolean;
    private showCreateVehicleButton: boolean = false;
    public canEditContract: boolean = false;

    public errorMessage: string;
    public successMessage: string;

    public loading: boolean;
    private userLogged: User;
    public canEdit: boolean;

    private userIsAdmin: boolean;


    constructor(private router: Router,
                private vehiclesService: VehiclesService,
                private contractsService: ContractsService,
                private bankService: BankService,
                private route: ActivatedRoute, private procedureService: ProcedureService, private loginService: LoginService, private navigationService: NavigationService) {
        this.init();
    }

    private init(): void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;
        this.contractValid = false;
        this.loading = false;
        this.canEdit = false;
    }



    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        this.loginService.getUserCredentials().subscribe(
            user => {
                this.userLogged = new User(user);
                this.userIsAdmin = this.userLogged.isAdmin();
                this.loginService.setUserLogged(this.userLogged);
            },
            ()=> {
            });

        this.sub = this.route.params.subscribe(params => {
            this.procedureId = params['procedureId'];
            this.getData();
        });
    }

    private getData(): void {
        this.getVehicles(1);
    }


    private createFormGroup(): void {
        this.form = new FormGroup({
            vehicleId: new FormControl(this.vehicleId, [Validators.required]),
            contractNumber: new FormControl(this.contract.contractNumber, [Validators.required])
        });
    }

    public getVehicles(page: number): void {
        this.errorMessage = null;
        if (this.procedureId) {
            this.loading = true;
            this.procedureService.getContract(this.procedureId).subscribe((data) => {
                this.contract = data.contract;
                if (this.contract) {
                    this.contractsService.getVehicles(this.contract.id, 1, 10000)  //TODO: Test, anda, pero el 1,10000 estan como de mas
                        .subscribe((data) => {
                                this.vehicles = data.content;
                                this.loading = false;
                                this.contractValid = true;
                                this.canEditVehicle = true;
                                this.canEditContract = false;
                                this.createFormGroup();

                                //TODO: Mostrar que si no tiene ningun vehiculo en ese contrato, un mensaje para cargar (o mostrarlo siempre, como prefieran)
                                if (this.vehicles.length == 0 && this.userIsAdmin) {
                                    this.showCreateVehicleButton = true;
                                }

                            },
                            () => {
                                this.bindError('Ocurrió un error al obtener los vehículos asociados al contrato.');
                            });
                }
            }, () => {
                this.bindError('Ocurrió un error al obtener el contrato asociado al trámite.');
            });
        }
    }

    public ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private clearMessages(): void {
        this.successMessage = null;
        this.errorMessage = null;
    }

    public save(): void {
        this.clearMessages();
        this.loading = true;

        if (this.vehicleId) {

            // Asocia el vehiculo al tramite, desasocia el contrato del tramite, y guarda el tramite
            this.procedureService.setVehicleId(this.vehicleId, this.procedureId).subscribe(
                (data) => {
                    this.loading = false;
                    this.canEditVehicle = false;
                    this.successMessage = 'El vehículo se asoció al trámite con éxito';
                },
                () => {
                    this.bindError('Ocurrió un error al asociar el vehículo al trámite.');
                });
        }
    }

    public goBack(event: any): void {
        event.preventDefault();
        window.history.back();
    }

    public editItem(item: Contract): void {
        if (item.id != null && !isNaN(parseInt(item.id))) {
            this.router.navigate(['app/home/editContract', item.id]);
        }
    }


    private bindError(messageError: string): void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/pendingProcedures/pendingProcedures.editor.component.ts
 **/